export interface UmpireLayoutConfig {
  numberOfItems?: number;
  containerClass: string;
  itemNgClass: (index: number) => Record<string, boolean>;
}
